import Vue from 'vue'
import Router from 'vue-router'
import home from '../pages/home/home.vue'
import comityall from '../pages/comityall/index'
import news from '../pages/news/index'
import vip from '../pages/vipservice/vipservice'
import branch from '../pages/branch/branch'
import gooble from '../pages/globalcooperation/globalcooperation'
import theme from '../pages/thematiccooperation/thematiccooperation'
import study from '../pages/academicresearch/academicresearch'
import art from '../pages/art/art'
import association from '../pages/associationservice/associationservice'
import activty from '../pages/activty/activty-detail'
import back from '../pages/activty/activty-back'

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            title: '首页',
            component: home
        },
        {
            path: '/comityall',
            name: 'comityall',
            title: '协会概况',
            component: comityall
        },
        {
            path: '/news',
            name: 'news',
            title: '新闻动态',
            component: news
        },
        {
            path: '/vip',
            name: 'vip',
            title: '会员服务',
            component: vip
        },
        {
            path: '/branch',
            name: 'branch',
            title: '协会服务',
            component: branch
        },
        {
            path: '/gooble',
            name: 'gooble',
            title: '国际合作',
            component: gooble
        },
        {
            path: '/theme',
            name: 'theme',
            title: '专题活动',
            component: theme
        },
        {
            path: '/study',
            name: 'study',
            title: '学术研究',
            component: study
        },
        {
            path: '/art',
            name: 'art',
            title: '文章详情',
            component: art
        },
        {
            path: '/activty',
            name: 'activty',
            title: '活动详情',
            component: activty
        },
        {
            path: '/association',
            name: 'association',
            title: '协会服务',
            component: association
        },
      {
        path: '/back',
        name: 'back',
        title: '活动回顾',
        component: back
      },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js